import { initializeApp, getApps, getApp } from "firebase/app";
import { getFirestore } from "firebase/firestore";
import { getStorage } from "firebase/storage";
import { getAuth, GoogleAuthProvider } from "firebase/auth";
import { getAnalytics, isSupported } from "firebase/analytics";
import { getPerformance } from "firebase/performance";

const firebaseConfig = {
  apiKey: "AIzaSyAl14-7CubC1-1ENMNGqki7oWBGMhMOF1g",
  authDomain: "its-your-story-dev.firebaseapp.com",
  projectId: "its-your-story-dev",
  storageBucket: "its-your-story-dev.firebasestorage.app",
  messagingSenderId: "189626850219",
  appId: "1:189626850219:web:794ddecfddb75f65f2d0ee",
  measurementId: "G-YGTRMRWNCZ",
};

const app = getApps().length ? getApp() : initializeApp(firebaseConfig);

export const auth = getAuth(app);
export const googleProvider = new GoogleAuthProvider();
export const db = getFirestore(app);
export const storage = getStorage(app);

// Initialize Analytics in browser environment (enabled in dev for testing)
let analytics: ReturnType<typeof getAnalytics> | null = null;
isSupported().then((supported) => {
  if (supported) {
    analytics = getAnalytics(app);
  }
});

// Initialize Performance Monitoring in browser environment
let perf: ReturnType<typeof getPerformance> | null = null;
if (typeof window !== "undefined") {
  try {
    perf = getPerformance(app);
  } catch {
    perf = null;
  }
}

export { analytics, perf };

const firebaseServices = {
  auth,
  googleProvider,
  db,
  storage,
  analytics,
  perf,
};

export default firebaseServices;
